/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import ORDER_STATUS from '../BaseComponent/ORDERSTATUS'

class ReportOrderStatus extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      orderStatusTypes: [],
      deleteModal: false,
      editModal: false,
      orderStatusName: '',
      subjectEnable: '',
      subjectId: '',
      categoryId: '',
      categoryList: [],
      printInfo: []
    }
  }

  callReportOrderStatus = (
    params = sessionStorage.getItem('params'),
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal')
  ) => {
    http
      .get(
        `${
          ORDER_STATUS.ORDERS_STATUS_ORDERSTATUS_REPORT
        }?export=false&pageNumber=${pageNumber}&pageSize=${pageSize}&${params}&sortBy=sortOrder_asc`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('sortBy', 'sortOrder_asc')
          // alert(JSON.stringify(response.data))
          this.setState({
            orderStatusTypes: response.data.object.result,
            total: response.data.object.countAll
          })
        } else {
          this.setState({
            orderStatusTypes: []
          })
        }
      })
  }

  componentDidMount() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    this.callReportOrderStatus()
  }

  onResultFetched(data) {
    this.setState({
      orderStatusTypes: data
    })
  }

  changeDropDown(data) {
    this.setState({
      orderStatusTypes: data,
      lengthProducts: this.state.total
    })
  }

  deleteOrderStatus = (id, name) => {
    sessionStorage.setItem('orderStatusId', id)
    this.setState({
      deleteModal: !this.state.deleteModal,
      orderStatusName: name
    })
  }

  toggleDelete = () => {
    sessionStorage.removeItem('orderStatusId')

    this.setState({
      deleteModal: !this.state.deleteModal,
      orderStatusName: ''
    })
  }
  deleteCancel = () => {
    sessionStorage.removeItem('orderStatusId')

    this.setState({
      deleteModal: !this.state.deleteModal,
      orderStatusName: ''
    })
  }
  deleteOk = () => {
    let orderStatusId = sessionStorage.getItem('orderStatusId')
    let data = {
      orderStatusId: Number(orderStatusId)
    }
    http.post(`${ORDER_STATUS.ORDERS_STATUS_ORDERSTATUS_DELETE}`, data, {}).then((response) => {
      if (response.data.error == null) {
        message.success('وضعیت با موفقیت حذف شد')
        this.deleteCancel()
        this.callReportOrderStatus()
        sessionStorage.setItem('pageNumber', '1')
        sessionStorage.setItem('dropDownVal', '10')
      } else {
        message.error(response.data.description)
      }
    })
  }

  editOrderStatus = (num, id, name, enable, color, sortOrder) => {
    this.setState({
      editModal: !this.state.editModal,
      orderStatusId: id,
      orderStatusName: name,
      orderStatusEnable: enable,
      orderStatusColor: color,
      orderStatussortOrder: sortOrder
    })
  }

  editCancel = () => {
    this.setState({
      editModal: !this.state.editModal,
      orderStatusId: '',
      orderStatusName: '',
      orderStatusEnable: '',
      orderStatusColor: '',
      orderStatussortOrder: ''
    })
  }
  toggleEdit = () => {
    this.editCancel()
  }

  editOk = () => {
    var orderStatusName = document.getElementById('name').value
    var enabled = document.getElementById('enabled').value
    var color = document.getElementById('color').value
    var sortOrder = document.getElementById('sortOrder').value
    var formError = false
    var sortOrderError = false

    if (sortOrder !== '' && sortOrder.match(/[a-z A-Z آ-ی]/g)) {
      formError = true
      sortOrderError = true
      message.error('ترتیب نمایش باید عددی باشد')
    } else {
      if (!sortOrderError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let data = {
        orderStatusId: this.state.orderStatusId,
        orderStatusName,
        enabled,

        color,
        sortOrder: sortOrder === '' ? undefined : sortOrder
      }
      http.post(`${ORDER_STATUS.ORDERS_STATUS_ORDERSTATUS_UPDATE}`, data, {}).then((response) => {
        if (response.data.error === null) {
          message.success('ویرایش با موفقیت انجام شد')
          this.editCancel()
          this.callReportOrderStatus()
        } else {
          // message.error(response.data.description)
        }
      })
    }
  }

  exportExcel = () => {
    http
      .get(
        `${ORDER_STATUS.ORDERS_STATUS_ORDERSTATUS_REPORT}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            if (excelReport[i]['enabled']) {
              excelReport[i]['enabled'] = 'فعال'
            } else {
              excelReport[i]['enabled'] = 'غیر فعال'
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(`${ORDER_STATUS.ORDERS_STATUS_ORDERSTATUS_REPORT}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let printCol = ['ردیف', 'عنوان', 'ترتیب نمایش', 'وضعیت']

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="وضعیت سفارشات - وضعیت ها"
              headerColSpan={4}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={1}
              rightColSpan={2}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((orderStatus, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{orderStatus.orderStatusName}</td>
                  <td>{orderStatus.sortOrder}</td>

                  <td>{orderStatus.enabled ? 'فعال' : 'غیر فعال'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="وضعیت سفارشات - وضعیت ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'orderStatusName'}
                field={'orderStatusName'}
                title={'عنوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'sortOrder'}
                field={'sortOrder'}
                title={'ترتیب نمایش'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'enabled'}
                field={'enabled'}
                title={'وضعیت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>وضعیت سفارشات</li>
            <li>وضعیت</li>
          </ul>

          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="/base/orderStatus/addOrderStatus"
                  url={ORDER_STATUS.ORDERS_STATUS_ORDERSTATUS_REPORT}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl=""
                  printComponent={this.printTable}
                  execelUrl={ORDER_STATUS.ORDERS_STATUS_ORDERSTATUS_REPORT + '?export=true'}
                  excelColumns={[]}
                  titleAdd="افزودن شهر"
                  printLink=""
                />
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="showBaseTable">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>عنوان</td>
                    <td>ترتیب نمایش</td>
                    <td>رنگ</td>
                    <td>وضعیت فعال</td>
                    <td>ویرایش</td>
                    <td>حذف</td>
                  </tr>

                  {this.state.orderStatusTypes.map((orderStatus, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{orderStatus.orderStatusName}</td>
                      <td>{orderStatus.sortOrder}</td>
                      <td style={{backgroundColor: orderStatus.color}} />
                      <td>
                        {orderStatus.enabled ? (
                          <img src={require('../../image/confirm.svg')} alt="" />
                        ) : (
                          <img src={require('../../image/ignor.svg')} alt="" />
                        )}
                      </td>
                      <td>
                        <button
                          onClick={() =>
                            this.editOrderStatus(
                              index,
                              orderStatus.orderStatusId,
                              orderStatus.orderStatusName,
                              orderStatus.enabled,
                              orderStatus.color,
                              orderStatus.sortOrder
                            )
                          }
                        >
                          <img src={require('../../image/editDriver.svg')} alt="" />
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() => this.deleteOrderStatus(orderStatus.orderStatusId, orderStatus.orderStatusName)}
                        >
                          <img src={require('../../image/trash.svg')} alt="" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  urlParams={'sortBy=sortOrder_asc'}
                  total={this.state.total}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={ORDER_STATUS.ORDERS_STATUS_ORDERSTATUS_REPORT}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.deleteModal} toggle={this.toggleDelete} size="sm">
          <ModalHeader toggle={this.toggleDelete}>حذف وضعیت</ModalHeader>
          <ModalBody>
            <p className="titleSm">آیا از حذف وضعیت {this.state.orderStatusName} مطمئن هستید؟؟؟</p>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.deleteOk}>
              حذف رسانه تماس
            </button>
            <button className="cancelBtnModal" onClick={this.deleteCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.editModal} toggle={this.toggleEdit} size="sm">
          <ModalHeader toggle={this.toggleEdit}>ویرایش وضعیت سفارش</ModalHeader>
          <ModalBody>
            <div className="modalForm">
              <div className="formComponent">
                <label> نام وضعیت سفارش: </label>
                <input className="form-control" type="text" defaultValue={this.state.orderStatusName} id="name" />
              </div>

              <div className="formComponent">
                <label> رنگ: </label>
                <input type="color" className="form-control" defaultValue={this.state.orderStatusColor} id="color" />
              </div>

              <div className="formComponent">
                <label> وضعیت وضعیت سفارش: </label>

                <select className="form-control" name="enabled" id="enabled">
                  <option selected={this.state.orderStatusEnable == 1 ? true : false} value={1}>
                    فعال
                  </option>
                  <option selected={this.state.orderStatusEnable == 0 ? true : false} value={0}>
                    غیر فعال
                  </option>
                </select>
              </div>
              <div className="formComponent">
                <label> ترتیب نمایش: </label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={this.state.orderStatussortOrder}
                  id="sortOrder"
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.editOk}>
              ویرایش وضعیت سفارش
            </button>
            <button className="cancelBtnModal" onClick={this.editCancel}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default ReportOrderStatus
